import React from 'react';
import './portofolio.scss';
import Card from '../../Molecules/Card-Portofolio';
import { data } from './data'
const Portofolio = () => {
    return (
        <div className="portofolio-organisms" id="portofolio">
            <div className="container">
                <div className="heading-section">
                    <h2>Experience</h2>
                </div>
            </div>
            <div className="portofolio-item">
                <div className="row">
                    {
                        data.map((response) => (
                            <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                                <Card src={response.imgUrl} title={response.title} description={response.description}/>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default Portofolio;